import React from "react";
import PropTypes from "prop-types";
import Cancel from "rialto-icons/Close";
import Duplicate from "rialto-icons/DuplicateGreen";
import LockSmallUnlockedGreen from "rialto-icons/LockSmallUnlockedGreen";

import Translate from "utils/translate";

import styles from "./DealHeaderActions.css";

const { t } = new Translate("EnquiryHeader");

const DealHeaderActions = ({ isExecuted, onCancel, onRenew, onReopen }) => (
  <div className={styles.root}>
    {isExecuted && (
      <button className={styles.button} onClick={onCancel}>
        <Cancel size="xs" />
        {t("cancel")}
      </button>
    )}
    <button className={styles.button} onClick={onReopen}>
      <LockSmallUnlockedGreen size="xs" />
      {t("reopen")}
    </button>
    {isExecuted && (
      <button className={styles.button} onClick={onRenew}>
        <Duplicate size="xs" />
        {t("renew")}
      </button>
    )}
  </div>
);

DealHeaderActions.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onReopen: PropTypes.func.isRequired,
  onRenew: PropTypes.func.isRequired,
  isExecuted: PropTypes.bool,
};

export default DealHeaderActions;
